<template>
  <div ref="element" class="sm:col-span-6">
    <template v-if="type === 'choice'">
      <choice-element
        :id="id"
        :type="type"
        :label="label"
        :required="required"
        :error-message="errorMessage"
        class="input-primary w-full mb-2"
        :choices="choices"
        @update-field="validate"
      />
    </template>
    <template v-else-if="type === 'compound'">
      <compound-element
        :id="id"
        :name="name"
        :label="label"
        :required="required"
        :error-message="errorMessage"
        class="input-primary w-full mb-2"
        :children="children"
        @update-field="validate"
      >
      </compound-element>
    </template>
    <template v-else-if="type === 'checkbox'">
      <checkbox-element
        :id="id"
        :type="type"
        :label="label"
        :required="required"
        :error-message="errorMessage"
        class="input-primary w-full mb-2"
        :choices="choices"
        @update-field="validate"
      ></checkbox-element>
    </template>
    <template v-else-if="type === 'password'">
      <password-element
        v-if="type !== 'choice'"
        :id="id"
        :type="type"
        :label="label"
        :required="required"
        :error-message="errorMessage"
        class="input-primary w-full mb-2"
        @update-field="validate"
      />
      <SingleAccordion
        v-if="name == 'passwordRepeated'"
        :title="$t('ssosbk.register.passwordGuidelinesTitle')"
        class="mt-3"
      >
        {{ $t("ssosbk.register.passwordGuidelines") }}
      </SingleAccordion>
    </template>
    <template v-else>
      <input-element
        v-if="type !== 'choice'"
        :id="id"
        :type="type"
        :label="label"
        :required="required"
        :error-message="errorMessage"
        class="input-primary w-full mb-2"
        @update-field="validate"
      />
    </template>
  </div>
</template>

<script>
import InputElement from "./InputElement.vue";
import ChoiceElement from "./ChoiceElement.vue";
import CompoundElement from "./CompoundElement.vue";
import CheckboxElement from "./CheckboxElement.vue";
import PasswordElement from "./PasswordElement.vue";
import SingleAccordion from "../layout/SingleAccordion.vue";

export default {
  name: "FormElement",
  components: {
    SingleAccordion,
    CheckboxElement,
    CompoundElement,
    ChoiceElement,
    InputElement,
    PasswordElement,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: false,
    },
    modelValue: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    validation: {
      type: Function,
      default: () => true,
    },
    errorMessage: {
      type: String,
      default: "",
    },
    errorId: {
      type: String,
      default: "",
    },
    choices: {
      type: Array,
      default: () => [],
    },
    children: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      error: false,
    };
  },
  computed: {
    labelText() {
      return `${this.label} ${this.required ? "*" : ""}`;
    },
  },
  methods: {
    validate(value) {
      this.$emit("update:modelValue", value);
    },
    scrollToError() {
      if (this.errorMessage) {
        const y =
          this.$refs.element.getBoundingClientRect().top + window.scrollY - 100;

        window.scroll({
          top: y,
          behavior: "smooth",
        });
      }
    },
  },
};
</script>
